// Single selector value; the backend stores `w2_everify` as type `w2` + `requires_everify: true`.
export type CompanyTypeValue = '1099' | 'w2' | 'w2_everify'

export const COMPANY_TYPE_OPTIONS: {
  label: string
  value: CompanyTypeValue
}[] = [
  { label: '1099', value: '1099' },
  { label: 'W2', value: 'w2' },
  { label: 'W2 (requires E-Verify)', value: 'w2_everify' },
]

/** Splits the single selector value into the backend's `type` + `requiresEverify`. */
export const companyTypeToFields = (
  value: CompanyTypeValue
): { type: 'w2' | '1099'; requiresEverify: boolean } => {
  switch (value) {
    case '1099':
      return { type: '1099', requiresEverify: false }
    case 'w2':
      return { type: 'w2', requiresEverify: false }
    case 'w2_everify':
      return { type: 'w2', requiresEverify: true }
  }
}

/** Inverse of {@link companyTypeToFields}; seeds the selector from stored fields. */
export const fieldsToCompanyType = (
  type: 'w2' | '1099',
  requiresEverify: boolean
): CompanyTypeValue => {
  if (type === '1099') {
    return '1099'
  }
  return requiresEverify ? 'w2_everify' : 'w2'
}
